import Cookies from "js-cookie";
import {Outlet , Navigate} from "react-router-dom";

const useAuth = () =>{
  const token = Cookies.get("accessToken");
  if(token){
    return true
  }else{
        return false
    }
}

const PrivateRoutes =() =>{
    const auth = useAuth()
return(
    auth ? <Outlet/> : <Navigate to="/"/>
)
}

export default PrivateRoutes;